import { type AnyRoute, createRoute } from "@tanstack/react-router";

import { F2fTransaction } from "./F2fTransaction";
import { OnlineTransaction } from "./OnlineTransaction";

export function createF2fTransactionRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "clients/$clientId/f2f/transactions/$transactionId",
    component: F2fTransaction,
    staticData: { reducedMobileTopPadding: true },
    head: (ctx) => ({
      meta: [{ title: "F2F Transaction " + ctx.params.transactionId }],
    }),
  });
}

export function createOnlineTransactionRoute<P extends AnyRoute>(parent: P) {
  return createRoute({
    getParentRoute: () => parent,
    path: "clients/$clientId/online/transactions/$transactionId",
    component: OnlineTransaction,
    staticData: { reducedMobileTopPadding: true },
    head: (ctx) => ({
      meta: [{ title: "Online Transaction " + ctx.params.transactionId }],
    }),
  });
}
